import React, { lazy, Suspense, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PageLoadingSpinner from '@jobmatchme/ui/es/components/PageLoadingSpinner';
import ThemeProvider from '@jobmatchme/ui/es/provider/ThemeProvider';
import { withRoutes } from '@jobmatchme/routing/es/provider/External';
import Button from '@jobmatchme/ui/es/components/Button';
import Link from '@jobmatchme/ui/es/components/Link';
import Container from '@material-ui/core/Container';
import SectionKeyVisual from '../SectionKeyVisual';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PageHeader = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'bcpageheader' */'../../common/CleanHeader');
});
var SectionHow = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'bcsechow' */'../SectionHow');
});
var SectionCallToAction = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'pcseccta' */'../SectionCallToAction');
});
var SectionMap = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'pcsecmap' */'../SectionMap');
});
var SectionWhy = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'pcsecwhy' */'../SectionWhy');
});
var Footer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'pcsecfooter' */'../../../truck/common/Footer');
});
var DriverPage = function DriverPage(_ref) {
  var applicationRoutes = _ref.applicationRoutes;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var translateNs = 'landingpage-components:driverPage';

  // Its used for Adwords Compaigns
  var getUtmParams = function getUtmParams() {
    var queryString = window && window.location.search;
    localStorage.setItem('utmStrings', queryString);
  };
  useEffect(function () {
    return getUtmParams();
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Helmet, {
      children: [/*#__PURE__*/_jsx("title", {
        children: t("".concat(translateNs, ".meta.title"))
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: t("".concat(translateNs, ".meta.description"))
      }), /*#__PURE__*/_jsx("meta", {
        name: "keywords",
        content: t("".concat(translateNs, ".meta.keywords"))
      })]
    }), /*#__PURE__*/_jsxs(ThemeProvider, {
      variant: "pc",
      children: [/*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx("div", {}),
        children: /*#__PURE__*/_jsx(PageHeader, {
          variant: 'pc',
          pcLogin: true,
          bcLink: /*#__PURE__*/_jsx(Link, {
            to: 'https://jobmatch.me/de-de/arbeitgeber/lkw-fahrer-finden/',
            id: "arbeitgeber",
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              size: "small",
              color: "white",
              children: t("".concat(translateNs, ".gkButton"))
            })
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        itemScope: "itemscope",
        itemType: "http://schema.org/WebPage",
        style: {
          marginRight: '-1px'
        },
        children: [/*#__PURE__*/_jsx(SectionKeyVisual, {}), /*#__PURE__*/_jsxs(Container, {
          noPadding: true,
          style: {
            padding: '0px',
            width: '100%',
            overflowX: 'hidden'
          },
          children: [/*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {}),
            children: /*#__PURE__*/_jsx(SectionHow, {})
          }), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {}),
            children: /*#__PURE__*/_jsx(SectionCallToAction, {})
          }), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {}),
            children: /*#__PURE__*/_jsx(SectionMap, {})
          }), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {}),
            children: /*#__PURE__*/_jsx(SectionWhy, {})
          })]
        }), /*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx(PageLoadingSpinner, {
            fullHeight: true
          }),
          children: /*#__PURE__*/_jsx(Footer, {})
        })]
      })]
    })]
  });
};
export default /*#__PURE__*/React.memo(withRoutes(DriverPage));